import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import { Box } from "@mui/material";

import ShakingHandsWithRobot from "../../assets/ShakingHandsWithRobotLight.png";

export default function MainInfo({ scrollToBottom, lessThanXL }) {
  return (
    <>
      <section>
        <Box
          sx={{
            paddingLeft: !lessThanXL ? "70px" : "21px",
            paddingRight: !lessThanXL ? "70px" : "21px",
          }}
        >
          <Grid mt={12} container>
            <Grid item md={12}>
              <Box
                component="header"
                sx={{
                  borderRadius: "16px",
                  paddingTop: !lessThanXL ? undefined : "30px",
                  paddingBottom: "30px",
                  backgroundColor: "transparent",
                }}
              >
                <Grid container alignItems="center">
                  <Grid item sm={12} md={7}>
                    <Typography
                      variant="h1"
                      component="h1"
                      sx={{
                        color: "#1F1F1F",
                        fontSize: !lessThanXL ? "44px" : "32px",
                      }}
                      fontWeight="700"
                      gutterBottom
                    >
                      Get insights from your {!lessThanXL ? <br /> : ""}{" "}
                      documents{" "}
                      <Typography
                        fontWeight="700"
                        component="span"
                        sx={{
                          paddingRight: "10px",
                          fontSize: !lessThanXL ? "44px" : "32px",
                          fontStyle: !lessThanXL ? "italic" : "",
                          background: (theme) => theme.palette.gradient.toTop,
                          WebkitBackgroundClip: "text",
                          WebkitTextFillColor: "transparent",
                        }}
                      >
                        80% faster with AI
                      </Typography>
                    </Typography>

                    {lessThanXL && (
                      <Grid
                        mt={5}
                        mb={5}
                        item
                        sm={12}
                        md={6}
                        sx={{ textAlign: "center" }}
                      >
                        <img
                          loading="lazy"
                          height="250px"
                          src={ShakingHandsWithRobot}
                          alt="Person shakinng hands with a robot"
                        />
                      </Grid>
                    )}

                    <Typography
                      variant="body1"
                      fontSize={!lessThanXL ? "18px" : "20px"}
                      fontWeight="400"
                      color="#393939"
                      maxWidth="550px"
                      mb={3}
                    >
                      Seamlessly engage with your documents. Chat, summarize,
                      and organize everything in one platform to quickly extract
                      insights and enhance your productivity.
                    </Typography>

                    <Button
                      onClick={scrollToBottom}
                      variant="contained"
                      aria-label="Request access to DokuSense"
                      sx={{ backgroundColor: "#466A88", borderRadius: "14px" }}
                    >
                      Request access
                    </Button>
                  </Grid>

                  {!lessThanXL && (
                    <Grid
                      mt={2}
                      item
                      sm={12}
                      md={5}
                      sx={{ textAlign: "center" }}
                    >
                      <img
                        height="520px"
                        width="520px"
                        loading="lazy"
                        src={ShakingHandsWithRobot}
                        alt="Person shakinng hands with a robot"
                      />
                    </Grid>
                  )}
                </Grid>
              </Box>
            </Grid>
          </Grid>
        </Box>
      </section>
    </>
  );
}
